import { connect } from 'react-redux';

import IntercomView from './IntercomView.jsx';
import { fetchIntegrations } from "src/legacy/redux/actions/integrations.jsx";
import { getIntegrationForType } from 'src/legacy/redux/actions/integrations.jsx';
import withUseHooks from 'src/legacy/components/withUseHooks.jsx';


const mapStateToProps = (state, ownProps) => {
  let integration = getIntegrationForType(state, 'intercom');
  return {
    'integration': integration,
    integrations: state.legacyRootReducer.settings.integrations,
    deactivating: state.legacyRootReducer.settings.integrations.chat.deactivation.deactivating
  }
}

const mapDispatchToProps = (dispatch) => {
  return {

    fetchIntegrations: () => {
      return dispatch(fetchIntegrations());
    }

    }
}

const IntercomPage = connect (
    mapStateToProps,
    mapDispatchToProps
)(IntercomView);

export default withUseHooks(IntercomPage);
